import { useQuery } from '@tanstack/react-query';
import { SectorComercial, UnidadNegocio } from '../../../../../types';
import { HttpCacheOperacion } from '../../../api/httpCacheOperacion';
import { OperacionADCMEntidadCache } from '../types/dto';


export const useADCMUnidadNegocio = (codPais: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: unidadNegocio = [],
    isLoading,
    isError,
    error
  } = useQuery<UnidadNegocio[], Error>({
    queryKey: ['ADCM-unidad-negocio', codPais, codSistema],
    queryFn: () => HttpCacheOperacion.getUnidadesNegocioPorPaisYSistema(codPais!, codSistema!),
    enabled: !!codPais && !!codSistema
  })

  return {
    unidadNegocio,
    isLoading,
    isError,
    error
  }
}


export const useADCMSectorComercialTipos = (codUnidadNegocio: number | undefined | null, codSistema: number | undefined | null) => {
  const {
    data: sectorComercialTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<SectorComercial[], Error>({
    queryKey: ['ADCM-sector-comercial-tipos', codUnidadNegocio, codSistema],
    queryFn: () => HttpCacheOperacion.getSectoresComercialesPorUnidadNegocio(codUnidadNegocio!, codSistema!),
    enabled: !!codUnidadNegocio && !!codSistema
  })

  return {
    sectorComercialTipos,
    isLoading,
    isError,
    error
  }
}

export const useADCMClienteTipos = (codPais: number | undefined | null) => {
  const {
    data: clienteTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<OperacionADCMEntidadCache[], Error>({
    queryKey: ['ADCM-clinete-tipos', codPais],
    queryFn: () => HttpCacheOperacion.getADCMClienteTipos(codPais!),
    enabled: !!codPais
  })

  return {
    clienteTipos,
    isLoading,
    isError,
    error
  }
}

export const useADCMEmisorTipos = (codPais: number | undefined | null) => {
  const {
    data: emisorTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<OperacionADCMEntidadCache[], Error>({
    queryKey: ['ADCM-emisor-tipos', codPais],
    queryFn: () => HttpCacheOperacion.getADCMEmisorTipos(codPais!),
    enabled: !!codPais
  })

  return {
    emisorTipos,
    isLoading,
    isError,
    error
  }
}

export const useADCMTransaccionTipos = (codPais: number | undefined | null) => {
  const {
    data: transaccionTipos = [],
    isLoading,
    isError,
    error
  } = useQuery<OperacionADCMEntidadCache[], Error>({
    queryKey: ['ADCM-transaccion-tipos', codPais],
    queryFn: () => HttpCacheOperacion.getADCMTransaccionTipos(codPais!),
    enabled: !!codPais
  })

  return {
    transaccionTipos,
    isLoading,
    isError,
    error
  }
}